<mat-card>
  <p8-layout-settings-header [titlePath]="[formModel?.nom, listRequestersModel?.name, 'Gestion des membres']"
                             [iconRacine]="'person'"></p8-layout-settings-header>
  <mat-card-content>
    <mat-card-subtitle>
      Cette interface vous permet d'ajouter ou d'enlever des membres à cette liste. Cette liste pourra être utilisé dans les demandes d'avis sur une demande du formulaire "{{formModel?.nom}}".
    </mat-card-subtitle>
    <div fxLayoutAlign="end">
      <mat-card-actions align="end">
        <button mat-raised-button (click)="openAddOrUpdateMember('add')"
                aria-disabled="false" color="accent"
                matTooltipPosition="right" matTooltip="Ajouter un membre à cette liste">
          <i class="fa fa-plus"></i> Ajouter un membre à cette liste
        </button>
      </mat-card-actions>
    </div>
    <app-data-table *ngIf="listRequestersModel"
                    [actions]="actions"
                    [columns]="columns"
                    [dataSource]="dsRequesters"
                    [extraParams]="extraParams"
                    [filterDisplay]="true"
                    [flexAction]="5"
                    [flexColumn]="90"
                    [minFilter]="1" [pageSize]="10"
                    [pageSizesList]="[5,10,25]"
                    [placeHolderFilter]="'Rechercher un membre dans la liste'"
                    [toolTipFilter]="'Rechercher un membre dans la liste'"
                    [refreshButton]="false"
                    [refreshIcone]="true"
                    [showFirstLastButtons]="true"
                    [showLoader]="true"
    >
    </app-data-table>
  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button (click)="goListToListsRequesters()"
            aria-disabled="false"
            matTooltipPosition="right" matTooltip="Retourner à la liste des listes">
      Retour à la liste des listes pour ce formulaire
    </button>
  </mat-card-actions>
</mat-card>
